// 国籍选择模块 @author linsc
<template>
  <div>
    <div class="all-accept-country-mask">
      <el-main class="all-accept-country-select-wrap">
        <el-container class="select-content">
          <el-header id="search-header" class="search-box">
            <el-input class="search-input" v-model="searchVal" placeholder="请输入关键字搜索">
              <el-button slot="prepend" icon="el-icon-search"></el-button>
            </el-input>
          </el-header>
          <el-container class="fund-item-wrap" v-if="showSearchData">
            <el-main>
              <ul class="country-wrap">
                <!-- 默认国籍列表 -->
                <li>
                  <div v-for="(value,key) in sortCountryList" :id="key" :key="key" :class="key" class="alphaItem">
                    <p>{{key}}</p>
                    <ul class="select-wrap">
                      <li v-for="(fundItem,index) in value" :class="{selected: selected == fundItem.DICT_ITEM }"
                        class="select-item" :key="index">
                        <!-- <img
                          class="country-icon"
                          :src="require(`@img/material/country_icon/countrys/${getIcons(fundItem.DICT_ITEM)}.png`)"
                        />-->
                        <div class="fundItem-content" :ref="fundItem.COUNTRY_NAME" @click="changeState(fundItem)"
                          :class="{selected: selected == fundItem.DICT_ITEM }">{{fundItem.COUNTRY_NAME}}</div>
                      </li>
                    </ul>
                  </div>
                </li>
                <!-- 搜索结果 -->
                <li class="alphaItem" v-if="!showSearchData">
                  <ul class="select-wrap">
                    <li v-for="(fundItem,index) in selectedInfoArr" :key="index"
                      :class="{selected: selected == fundItem.DICT_ITEM }" class="select-item">
                      <!-- <img
                        class="country-icon"
                        :src="require(`@img/material/country_icon/countrys/${getIcons(fundItem.DICT_ITEM)}.png`)"
                      />-->

                      <div class="fundItem-content" :ref="fundItem.COUNTRY_NAME" @click="changeState(fundItem)"
                        :class="{selected: selected == fundItem.DICT_ITEM }">{{fundItem.COUNTRY_NAME}}</div>
                    </li>
                  </ul>
                </li>
              </ul>
            </el-main>
          </el-container>
          <el-container class="fund-item-wrap" v-if="!showSearchData">
            <el-main>
              <ul class="country-wrap">
                <!-- 搜索结果 -->
                <li class="alphaItem" v-if="selectedInfoArr.length>0">
                  <ul class="select-wrap">
                    <li v-for="(fundItem,index) in selectedInfoArr" :key="index"
                      :class="{selected: selected == fundItem.DICT_ITEM }" class="select-item">
                      <!-- <img
                        class="country-icon"
                        :src="require(`@img/material/country_icon/countrys/${getIcons(fundItem.DICT_ITEM)}.png`)"
                      />-->

                      <div class="fundItem-content" :ref="fundItem.COUNTRY_NAME" @click="changeState(fundItem)"
                        :class="{selected: selected == fundItem.DICT_ITEM }">{{fundItem.COUNTRY_NAME}}</div>
                    </li>
                  </ul>
                </li>
                <li v-else class="biz-list biz-list-empty">
                  <div class="empty-main">
                    <img class="image" src="../../../static/assets/img/home/04search/pic_wuneirong.png" />
                    <div class="result-txt">
                      <span class="search-name">“{{searchName}}”</span>下无内容
                      <br />请尝试更换关键词搜索
                    </div>
                  </div>
                </li>
              </ul>
            </el-main>
          </el-container>
        </el-container>
        <el-footer>
          <el-button class="el-button" round @click="goBack">返回</el-button>
          <el-button class="el-button" round @click="makeSure" :disabled="this.onSelectedCount == 0">确定</el-button>
        </el-footer>
      </el-main>
    </div>
  </div>
</template>

<script>
import stringPinyinConfig from "../../tools/stringPinyinConfig.js"; // 拼音处理插件
export default {
  data () {
    return {
      searchVal: "",
      sortCountryList: {},  // 存放关键字筛选过的数组
      selectedInfoArr: [], // 筛选结果
      onSelectedCount: 0,
      selected: "",
      showSearchData: true,
      searchName: "",
      transformY: 0,
      showCountryList: [],
    };
  },
  computed: {
  },
  mounted () {
    this.selected = "";
    this.searchVal = "";
    this.initModule();
    this.getsortCountryListData();
  },
  props: ["countryList"],
  watch: {
    searchVal (val) {
      let result = [];
      let sortCountryList = _.cloneDeep(this.sortCountryList);
      // 中文匹配
      if (/[\u4e00-\u9fa5]+/.test(val)) {
        for (let [key, value] of Object.entries(sortCountryList)) {
          let arr = sortCountryList[key].filter(item => {
            return item.COUNTRY_NAME.includes(val);
          });
          result = result.concat(arr);
        }
      } else {
        //非中文匹配
        let upperSearchBoxText = val.toUpperCase();

        for (let [key, value] of Object.entries(sortCountryList)) {
          if (sortCountryList[key].length > 0) {
            let arr = sortCountryList[key].filter(item => {
              let pinyin = stringPinyinConfig.ConvertPinyin(item.COUNTRY_NAME).toUpperCase(),
                firstCapital = stringPinyinConfig.getAllFirstCapital(item.COUNTRY_NAME).toUpperCase();
              if (pinyin.includes(upperSearchBoxText) || firstCapital.includes(upperSearchBoxText)) {
                return true;
              }
            });
            result = result.concat(arr);
          }

        }
      }

      this.showSearchData = val === "" ? true : false;
      this.selectedInfoArr = result;
      this.searchName = val;
    }
  },
  methods: {
    changeState (fundItem) {
      consoleLog(fundItem);
      if (this.selected == fundItem.COUNTRY_NAME) {
        this.selected = "";
        this.onSelectedCount = 0;
      } else if (this.selected != fundItem.DICT_ITEM) {
        this.selected = fundItem.DICT_ITEM;
        this.onSelectedCount = 1;
      }
    },
    getsortCountryListData () {
      let sortCountryList = {};
      this.onSelectedCount = 0;
      _.each(this.showCountryList, function (fundItem) {
        if (!fundItem) {
          return false;
        }
        let firstCapital = stringPinyinConfig.getFirstCapital(fundItem.COUNTRY_NAME);
        if (!(sortCountryList[firstCapital] instanceof Array)) {
          sortCountryList[firstCapital] = [];
        }
        sortCountryList[firstCapital].push(fundItem);
      });
      this.sortCountryList = sortCountryList;

    },
    initModule () {
      this.showCountryList = this.countryList
        .map((val) => {
          val.COUNTRY_NAME = val.COUNTRY_NAME || val.DICT_ITEM_NAME;
          val.firstCapital = stringPinyinConfig.getFirstCapital(val.COUNTRY_NAME);
          return val;
        })
        .sort((a, b) => {
          if (a.firstCapital < b.firstCapital) { return -1; }
          if (a.firstCapital > b.firstCapital) { return 1; }
          if (a.firstCapital == b.firstCapital) { return 0; }
        });
    },
    searchCountry () {
    },
    goBack () {
      this.$emit("close");
    },
    makeSure () {
      this.$emit("checkCountry", { selectVal: this.selected });
    },
    // getIcons (code) {
    //   let result = "";
    //   for (let [key, val] of Object.entries(icons_map)) {
    //     if (val.includes(code)) {
    //       result = key;
    //       break;
    //     }
    //   }
    //   return result;
    // }
  }
};
</script>

<style lang="less">
.nav-left {
  height: unset !important;
}
#kmos {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
@keyframes pop {
  from {
    bottom: -100%;
  }
  to {
    bottom: 0;
  }
}
.all-accept-country-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 99;
  background: rgba(0, 0, 0, 0.9) !important;
}
#search-header {
  margin-left: auto;
  margin-top: auto;
  margin-bottom: auto;
  .search-input {
    border-bottom: 1px solid #cbd0d3;
    .el-input-group__prepend {
      border: 0px solid #000;
      background: #fff;
    }
    .el-input__inner {
      border: 0px solid #000;
    }
  }
}

.all-accept-country-select-wrap {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  padding: 0;
  border-radius: 4px;

  position: absolute;
  width: 1300px;
  height: 920px;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  animation: pop 0.2s linear;
  .select-content {
    background: #fff;
    height: 600px;
    flex-direction: column;
    display: flex;
  }

  // margin-left: 0px;
  // margin-top: 0px;
  // margin-bottom: 0px;
  .search-box {
    position: relative;
    height: auto !important;
    padding-top: 27px;
    width: 65%;
    margin: 20px auto;
    .search-input {
      border-bottom: 1px solid #cbd0d3;
      .el-input-group__prepend {
        border: 0px solid #000;
        background: #fff;
      }
      .el-input__inner {
        border: 0px solid #000;
      }
    }
    .showSearchData {
      position: absolute;
      width: 900px;
      z-index: 100;
      font-size: 25px;
      background-color: white;
      ul {
        margin: 0px;
        padding-left: 0px;
        li {
          list-style: none;
          border-bottom: 1px solid #aaaaaa;
          width: 880px;
          height: 64px;
          line-height: 64px;
          background-color: #ffffff;
          padding-left: 20px;
        }
      }
    }
    .el-input {
      margin-bottom: 0;
      width: 100%;
      height: 68px;
      // border-radius: 5px;

      font-size: 24px;
      color: #c9d4dc;
      background-color: #ffffff;
      input {
        height: 68px;
        padding-left: 25px;
      }
    }
  }

  .fund-item-wrap {
    font-size: 20px;
    margin: 0px auto;
    width: 1180px;
    overflow-y: auto;
    overflow-x: visible;
    .alphaItem {
      z-index: 1;
      list-style: none;
      p {
        margin: 10px 0;
        padding: 10px;
        font-size: 24px;
        font-weight: bold;
        background-color: #eff2f6;
      }
      .select-wrap {
        padding: 0;
        .select-item {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          width: 225px;
          height: 100px;
          margin: 10px 22px;
          border: 2px solid #9fa2ae;
          border-radius: 4px;
          &.selected {
            border: 2px solid #1062d1;
            color: #1062d1;
            background-color: #cfe0f6;
          }
          // padding: 10px 20px;
          .fundItem-content {
            display: inline-block;
            padding: 10px 10px;
            width: 100%;
            font-size: 24px;
            text-align: center;
          }
          // .country-icon {
          //   width: 40px;
          //   height: 40px;
          // }
        }
      }
    }
    .aside-right {
      align-self: center;
      width: 35px !important;
      display: none;
      a {
        position: relative;
        text-decoration: none;
        display: block;
        height: auto;
        margin-top: 5px;
        color: black;
        text-align: right;
        width: 35px;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        &:first-child {
          margin-top: 0;
        }
      }
    }
  }
  .el-footer {
    box-sizing: border-box;
    padding: 25px 0;
    height: 130px !important;
    width: 100%;
    border-top: 1px solid #d6d6d6;
    text-align: center;
    background-color: white;
    overflow: hidden;
    .el-button {
      min-width: 220px;
      width: auto;
      height: 80px;
      margin: 0 20px;
      // background: linear-gradient(45deg, #3556dd, #4667e9);
      border-radius: 4px;
      font-size: 32px;
      font-weight: 500;
      // color: #fff;
      &:first-child {
        color: #5172f6;
        background-color: #ffffff;
        box-shadow: 0px 6px 14px 0px rgba(0, 0, 0, 0.08);
        border: solid 2px #5172f6;
      }
      &:last-child {
        color: #fff;
        background: linear-gradient(45deg, #3556dd, #4667e9);
        &.is-disabled {
          background: #bbc8f6;
          box-shadow: 0px 6px 14px rgba(146, 153, 162, 0.26);
          border-color: #f5f7fa;
        }
      }
    }
  }
  .biz-list {
    display: inline-flex;
    flex-wrap: wrap;
    align-content: flex-start;
    box-sizing: border-box;
    margin: 0;
    padding: 0 62px;
    width: 100%;
    list-style: none;
    .biz-item {
      flex: 0 1 25%;
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      padding-top: 24px;
      height: 240px;
      box-sizing: border-box;
      overflow: hidden;
      .biz-icon {
        display: inline-flex;
        width: 116px;
        height: 120px;
        justify-content: center;
        // img {
        //   display: block;
        //   width: 100%;
        //   height: auto;
        // }
      }
      .biz-title {
        margin-top: 5px;
        width: 195px;
        font-size: 24px;
        font-weight: 500;
        color: #000;
        line-height: 30px;
        text-align: center;
        &.biz-title-long {
          width: 236px;
          font-size: 20px;
          line-height: 26px;
        }
        .is-match {
          color: #3069a3;
        }
      }
    }
    // &::-webkit-scrollbar {
    //   display: block !important;
    //   width: 8px;
    // }
    // &::-webkit-scrollbar-thumb {
    //   border-radius: 2px;
    //   background-color: #b2b8bb;
    // }
    &.biz-list-empty {
      flex-direction: column;
      align-items: center;
      align-content: center;
      .empty-main {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .result-txt {
          margin: 11px 0 0;
          font-size: 24px;
          font-weight: 500;
          line-height: 36px;
          color: #1a1a1a;
          text-align: center;
          .search-name {
            color: #1e64f3;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/preEntry/countrySelect.vue